import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions } from '@angular/material/checkbox';

@Component({
    selector: 'dragonfly-tri-state-checkbox',
    templateUrl: './tri-state-checkbox.component.html',
    styleUrls: ['./tri-state-checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TriStateCheckboxComponent),
            multi: true,
        },
        { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { clickAction: 'noop' } as MatCheckboxDefaultOptions },
    ],
    standalone: false
})
export class TriStateCheckboxComponent implements ControlValueAccessor {
  @Input() options = [null, true, false];

  value: boolean | null;

  disabled: boolean;

  private onChange: (val: boolean | null) => void;
  private onTouched: () => void;

  writeValue(value: boolean | null) {
    this.value = value !== null ? value : this.options[0];
  }

  next() {
    this.onChange((this.value = this.options[(this.options.indexOf(this.value) + 1) % this.options.length]));
    this.onTouched();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}
